import React, { memo, useEffect, useState, useContext } from "react";
import Header from "../Components/Header";
import PageTitleSection from "../Components/PageTitleSection";
import FooterSection from "../Components/FooterSection";
import MapContactUsSection from "../Components/MapContactUsSection";
import Spacer from "../Components/Spacer";

import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import HttpHelper from '../service/httpService'
import { getSettingValue } from "../service/userService";

const ContactUsPage = (props) => {
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const titleWebsite = "Contact Us";
    const descriptionWebsite = "We delivers measurable business value through process automation. Let us know your technical challenges, and our experts will help you resolve them. In addition, we provide solutions for patient and clinical care, telemedicine and remote patient care,  banking, Azure, AWS, and more.";
    const submitForm = async (data, event) => {
        await HttpHelper.post("website/ContactInquiry", data).then((response) => {
            if (response.status === 200) {
                event.target.reset();
                props.showToast("success", "Your inquiry submited succesfully, We will get back to you shortly.");
            } else {
                console.log(response.data);
            }

        }).catch((error) => {
            console.log(error);
        })


    }
    useEffect(() => {
        document.title = titleWebsite;
        document.getElementsByTagName("meta")[2].content = descriptionWebsite;
        document.description = descriptionWebsite;
        window.scrollTo(0, 0);
    }, [titleWebsite, descriptionWebsite]);


    return (
        <>
            <ToastContainer />
            <Header />
            <PageTitleSection
                title="Contact Us"
                pagetitle="Contact Us"
                bgImage="assets/images/pages/contact-us-new.jpg"
            />
            <section className={`section section-padding-bottom-90 py-2 blackB`}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">           
                    <form className="row NewFormReDesign form-group" onSubmit={handleSubmit(submitForm)}>
                        <div className="col-md-12 text-center">
                            <h4>Please fill the following details.</h4>
                        </div>
                        <div className="col-md-6 col-12 mb-2">
                            <div className="form-group row">
                                <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Name : <span className="requiredAstric"> *</span></label>
                                <div className="col-md-12 col-12">
                                    <input type="text" className="form-control labelInputSize" minLength="6" {...register("name", { required: true })} />
                                    {errors.name?.type === 'required' && <p className="text-danger" role="alert">Name is required</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-12 mb-2">
                            <div className="form-group row">
                                <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Email : <span className="requiredAstric"> *</span></label>
                                <div className="col-md-12 col-12">
                                    <input type="text" className="form-control labelInputSize" {...register("email", { required: true, pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i })} />
                                    {errors.email?.type === 'pattern' && <p className="text-danger" role="alert">Email is not valid</p>}
                                    {errors.email?.type === 'required' && <p className="text-danger" role="alert">Email is required</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-12 mb-2">
                            <div className="form-group row">
                                <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Message : <span className="requiredAstric"> *</span></label>
                                <div className="col-md-12 col-12">
                                    <textarea className="w-100" {...register("message", { required: true, minLength: 50 })}></textarea>
                                    {errors.message?.type === 'required' && <p className="text-danger" role="alert">Message is not valid</p>}
                                    {errors.message?.type === 'minLength' && <p className="text-danger" role="alert">Message must be atleast 50 charecters.</p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-12 mb-2">
                            <div className="form-group row d-flex justify-content-center">
                                <div className="col-md-3"><button type="submit" style={{ width: "100%" }} className="btn btnTrailboss">Submit</button></div>
                            </div>
                        </div>
                            </form>
                        </div>
                    </div>                 

                </div>
                <div className="row mb-10">
                    <div className="col-md-6 mt-xl-10">
                        <section className="section blackBg py-2">
                            <MapContactUsSection bgClass="blackBg" Address="Address1" />
                        </section>
                    </div>
                    <div className="col-md-6 mt-xl-10">
                        <section className="section blackBg py-2">
                            <MapContactUsSection bgClass="blackBg" Address="Address2" />
                        </section>
                    </div>
                </div>
            </section>

           
            <FooterSection />
        </>
    )
}

export default memo(ContactUsPage);